// Core
import React, { FC, ReactElement, useRef } from 'react';
import Transition, { TransitionStatus } from 'react-transition-group/Transition';

// Styles
import Styles from './styles.module.scss';

// Instruments
import { opacityTransitionConfig } from 'utils/transitionConfig';
import errorImage from 'theme/assets/images/alw-contest/alw-error.png';

type AlienwareErrorProps = {
    className?: string;
    retryAction: () => void;
};

export const AlienwareError: FC<AlienwareErrorProps> = ({
    className,
    retryAction,
}): ReactElement => {
    const nodeRef = useRef(null);

    return (
        <Transition
            in
            appear
            mountOnEnter
            unmountOnExit
            timeout={opacityTransitionConfig().timeout}
            nodeRef={nodeRef}
        >
            {(state: TransitionStatus) => (
                <section
                    className={[Styles.container, className].filter(Boolean).join(' ')}
                    style={{
                        ...opacityTransitionConfig().defaultStyles,
                        ...opacityTransitionConfig().transitionStyles[state],
                    }}
                >
                    <img src={errorImage} alt='' className={Styles.image} />
                    <p className={Styles.title}>Oops something went wrong</p>
                    <p className={Styles.subtitle}>There was an error loading this!</p>

                    <div className={Styles.button} onClick={retryAction}>
                        Try again
                    </div>
                </section>
            )}
        </Transition>
    );
};
